import { CanDeactivateFn } from "@angular/router";

/**
 * How to use:
 * A component implements interface 'BlockOnError' and also method 'hasBlockingError()' -> specify what error should block navigation (prevent leaving the route).
 * In app.routes.ts: add canDeactivate: [preventLeaveOnErrorGuard] to the route where the component is used.
 * And of course, inform the user how to resolve the blocking error to be able to navigate away (div.alert, toast message, modal etc.).
 * @param component
 * @returns boolean
 */
export const preventLeaveOnErrorGuard: CanDeactivateFn<BlockOnError> =
  (component) => {

    if (!component?.hasBlockingError) return true;

    const block = component.hasBlockingError();

    if (!block) return true;

    return false;
  };

export interface BlockOnError {
  /** Return true if navigation should be blocked due to an error. */
  hasBlockingError(): boolean;
}
